var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "291px",
    height: "292px",
    viewBox: "-0.5 -0.5 291 292",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2023-08-22T06:28:06.634Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36\" version=\"21.6.8\" etag=\"787FTcmTHt-MUVSXJ8hG\"><diagram name=\"Page-1\" id=\"nBK2WJA4iZG3faUgx4F_\">7ZhNc5swEIZ/Dcd2EJgPH2s7bi+dyYwPbY6qWYOmMmKEHOP8+gqQABkoTgf3kORk7WuthJ53F41tuetj8ZXjLPnOIqCWY0eF5W4sx3GWtiM/SuVSKygIUK3EnERKa4UdeQEl2ko9kQhyY6JgjAqSmeKepSnshaFhztnZnHZg1Nw1wzH0hN0e0776g0QiqdXQCVr9G5A40Tsjf1l/c8R6sjpJnuCInTuS+2C5a86YqEfHYg20pKe51HnbkW+bB+OQilsSlBPPmJ7U2dRziYs+7DkhAnYZ3pfxWTpquatEHKmMkBziPKsRH0gBctWVhC4wSYFLzZbxgVC6ZpTxajl3sd2gtSd1zk5pVGZUy5SzdmpTfBJMSjHFea4WUY8JXEAxelTUAJSlB+wIgl/kFJ3gLxV0VXaejs+th47Wko5/jYhV3cTN4i1aOVB0h0m706RjiSQbPakqZvxLT7dfTSBwTQK+M0AADRFwZyCwmCbQ1kRp+kTl5YKz39AprQ1abL3VVcmlLIWBqqyTdfcGt5aYOwxY8Qz6OFE4hHMGmt40TflyycqhkOjghZWZqww4kXtVHBr9sRWnoFddrt7IqOpigQVhqQw/lWcdhD/u1H1t0TfOwqj6gbZHdth3CS1msMmftgnS6Et5KbW8OrzNjpAH5pef3eCpG2wKI7oYUIfwj+GGqHcBTsLu4PQGal5rHKgsmGdz+SHCaodHRuTGjZe+b3gZXFmUsxPfg8rp3nsjy+g8gXkMopdXuduc8SbDg1kNf1PWef/mVXMjzW9WeJ/uRN3uRO+oO8N5ujP0P3vGQtcX5nwVsJy3AgoimgKQ46fOuLW/DN6k+96Eba/u+Lvbrze6o//2X/3/uNGnzP7/14QM21/g9fT2jwz34Q8=</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 290,
    height: 290,
    rx: 43.5,
    ry: 43.5,
    fill: "#4fd1c5",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 180,
    height: 20,
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 260 L 84 120 L 152 120 L 172 260 Z",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    transform: "rotate(-180,118,190)",
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 106 100 L 106 30",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105 30 L 250 30",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 126 100 L 126.5 50",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.5 50 L 250 50",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250 50 L 250 30",
    fill: "none",
    stroke: "#d14f5b",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodLogo);
export default __webpack_public_path__ + "static/media/foodLogo.282267b16f754eedba867d795b238b63.svg";
export { ForwardRef as ReactComponent };